// ==============================|| MENU ITEMS - LOCATIONS ||============================== //

import { PERMISSIONS } from "../permissions/permissions";

const userManagementComponents = {
  id: 'user-management',
  path:"/user-management",
//   title: 'Forms',
  type: 'group',
  children: [
    {
      id: 'user-management-elements',
      title: 'menu.userMgnt',
      type: 'collapse',
      icon: 'ph ph-user',
      children: [
        {
          id: 'subadmin',
          title: 'menu.adminMgnt',
          type: 'item',
          url: '/user-management/sub-admin',
          permission: PERMISSIONS.USERS.VIEW
        },
        // {
        //   id: 'foodItems',
        //   title: 'Food Items',
        //   type: 'item',
        //   url: '/menu/FoodItems'
        // }
      ]
    }
  ]
};

export default userManagementComponents;